import { BlankV1 } from "../../grader/blank/v1.grader";
import { AnswerConfig } from "../../grader/grade-input";
import { ExtractInput } from "../extract-input";
import { ExtractOutput } from "../extract-output";
import { extractEditor } from "../utils/extract-editor";

export function extractBlankV1(
  extractInput: ExtractInput,
): ExtractOutput<BlankV1[]> {
  const { version, questionType, div } = extractInput;

  const editor = extractEditor(div);
  const inputs = editor.getElementsByTagName("input");

  const blanks: BlankV1[] = [];

  for (const input of Array.from(inputs)) {
    const value = input.value;
    let answerConfig: AnswerConfig | undefined = undefined;

    // camp-input 클래스가 있는 경우 data-answer-config 추출
    if (input.classList.contains("camp-input")) {
      const answerConfigAttr = input.getAttribute("data-answer-config");
      if (answerConfigAttr) {
        try {
          // HTML 엔티티 디코딩 후 JSON 파싱
          const decodedConfig = answerConfigAttr
            .replace(/&quot;/g, '"')
            .replace(/&amp;/g, "&")
            .replace(/&lt;/g, "<")
            .replace(/&gt;/g, ">");

          answerConfig = JSON.parse(decodedConfig) as AnswerConfig;
        } catch (e) {
          console.error(
            "❌ answerConfig 파싱 오류:",
            e,
            "원본:",
            answerConfigAttr,
          );
        }
      }
    }

    blanks.push({
      id: input.id,
      value,
      answerConfig,
    });
  }

  return {
    version, // 문제 버전
    questionType, // 문제 유형
    entryCount: blanks.length, // 추출된 행 수
    answerSheet: blanks, // 추출된 데이터
  };
}
